import type React from 'react';

import { XingletLoader } from '@xing-com/crate-xinglet';

import { useSearchStore } from '../../context';

export const SearchErrorDisplay: React.FC = () => {
  const error = useSearchStore((store) => store.error);
  const listLength = useSearchStore((store) => store.listLength);

  if (!error) return null;
  if (listLength > 0) return null;

  return (
    <XingletLoader
      name="@xing-com/crate-communication-error-pages"
      errorType="Generic"
    />
  );
};
